import axios from "functions/axios";

export const LoginAPI = (payload) =>
  axios.post("admin/login/", payload, { requiresAuth: false }).then((res) => res.data);

export const OauthLoginAPI = (access_token) =>
  axios.post("admin/oauth/", { access_token }, { requiresAuth: false }).then((res) => res.data);

export const AdminDetailDataAPI = () => axios.get("user/admin/detail/").then((res) => res.data);
